/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { Fragment } from 'react';
import { white } from '@theme/core/colors/color.palette';
import { OptionProps, WelcomeDropDownProps } from '@types';
import { List } from '../../App.styled';
import Link from '@components/Link/Link';
import { ListWrapper, ListItems, Hr } from './WelcomeDropdown.styled';
import isEmpty from 'lodash/isEmpty';
import memoize from 'fast-memoize';
import { lastDigits } from '@utils/lastDigits';

const getDropDownItem = memoize((_ele: OptionProps, _onClick, getSelectedOption) => {
    const { identifier, propertyAddress } = _ele;
    if (propertyAddress) {
        return (
            <Link id={`${identifier}_link`} data-testid="linkElement" onClick={() => getSelectedOption(_ele)} decoration="none">
                {`${propertyAddress?.address1} (...${lastDigits(identifier, 4)})`}
            </Link>
        );
    } else {
        return (
            <Link id={`${identifier}_link`} data-testid="linkElement1" onClick={() => getSelectedOption(_ele)} decoration="none">
                {`(...${lastDigits(identifier, 4)})`}
            </Link>
        );
    }
});

const WelcomeDropDown: React.FC<WelcomeDropDownProps> = React.forwardRef(
    ({ options, onClick, getSelectedOption, fontSize = '1rem', fontColor = `${white}`, separator = true, selectedOption }, ref) => {
        return (
            <ListWrapper role="welcomedropdown" ref={ref}>
                <List>
                    {!isEmpty(options) &&
                        options.map(ele => (
                            <Fragment key={ele.identifier}>
                                <ListItems
                                    fontSize={fontSize}
                                    fontColor={fontColor}
                                    disabled={ele.disabled}
                                    key={ele.name}
                                    id={ele.name}
                                    isSelected={ele.identifier === selectedOption.identifier}
                                >
                                    {getDropDownItem(ele, onClick, getSelectedOption)}
                                </ListItems>
                                {separator && <Hr role="separator" />}
                            </Fragment>
                        ))}
                </List>
            </ListWrapper>
        );
    }
);

export default WelcomeDropDown;
